import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ConnectMapService from '../../core/service'

//search company
export const getSearchCompany = createAsyncThunk(
  'connectMap/entityMap/getSearchCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.getSearchCompany(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//search person
export const getSearchPerson = createAsyncThunk(
  'connectMap/entityMap/getSearchPerson',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.getSearchPerson(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const getSearchCompanyForPersonFilter = createAsyncThunk(
  'connectMap/entityMap/getSearchCompanyForPersonFilter',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.getSearchCompany(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const uploadFileConnectMap = createAsyncThunk(
  'connectMap/entityMap/uploadFileConnectMap',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.uploadFileConnectMap(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)
